xplenty.directive('packageJsonImportForm', [
  function () {
    return {
      restrict: 'E',
      template:
        "<div class='package-json-import-form row'>" +
        "<span class='col-md-10 col-md-offset-1'>" +
        'Package JSON<br/>' +
        "<textarea class='form-control' ng-model='newPackageJson'></textarea>" +
        '</span>' +
        '</div>',
      replace: true,
      scope: {
        newPackageJson: '=ngModel',
      },
    };
  },
]);
